export default "https://assets.pclncdn.com/web/next-landing/80a0a33/_next/static/images/cobrand-cruises-com-promo-d1429ae64cc6c06121c3ad607ebc050a.jpg";